export default __webpack_public_path__ + "static/media/triste.0424558e.jpeg";